import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect,useState } from 'react';
import { Container } from 'react-bootstrap';
import '../style/service.css';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useRef } from 'react';
import { db } from '../database/firebase';
import { collection,getDocs,addDoc } from 'firebase/firestore';
import { doc,updateDoc,deleteDoc } from 'firebase/firestore';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

export default function DashboardAdmin() {
  
  const location = useLocation();
  const navigate = useNavigate();
  const [plans, setpalns] = useState([]); 
  const[getmessage,setgetmessage]=useState([]);
  const[hdelete,hsetha]=useState();
  const [uplans,setuppplans]=useState("");
  const [adsev, setadsev] = useState(
    { title: '', text: '', img: '',  },
  );

  const [addplane, setaddplane] = useState(
    { title: '', price: '', skils1: '', skils2: '',skils3: '',skils4: '',skils5: '',skils6: '', },
  );
  const [messg,setmssg]=useState("");
  useEffect(() => {
    if (!location.state?.fromLogin) {
      navigate('/');
    }
  }, [location, navigate]);
  /*serivces*/


  const [services, setserivces] = useState([]); 
  const [uppp,setuppp]=useState("")
  useEffect(() => {
      const fetchUsers = async () => {
          const querySnapshot = await getDocs(collection(db, "serivces"));
          const usersArray = querySnapshot.docs.map(doc => ({
              id: doc.id,
              ...doc.data()
            }));
          setserivces(usersArray);
          console.log(services)

        };
        fetchUsers();

  }, [uppp]);


  const sliderRef = useRef(null);
  const sliderRef2 = useRef(null);
  const sliderRef3 = useRef(null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    swipe: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const nextSlide = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  const nextSlide2 = () => {
    if (sliderRef2.current) {
      sliderRef2.current.slickNext();
    }
  };
  const nextSlide3= () => {
    if (sliderRef3.current) {
      sliderRef3.current.slickNext();
    }
  };
    /*start function to add*/
    const addproduct = async () => {
        try {
          const docRef = await addDoc(collection(db, "serivces"), {
           title:adsev.title,
           text:adsev.text,
           img:adsev.img,
          });
          console.log("Document ID:", docRef.id);
          setuppp(docRef.id);
                setadsev({ title: '', text: '', img: '' });
        } catch (error) {
          console.error("Error adding document:", error);
        }
      };
      /*end function to add*/
      /*delete*/
      const deleteproduct = async (productid) => {
        try {
          await deleteDoc(doc(db, "serivces", productid));
          console.log("User Deleted");
              setuppp(productid)
        } catch (error) {
          console.error("Delete Error:", error);
        }
      };
      /*delete*/


  /*services*/
  /*plans*/

  useEffect(() => {
      const fetchUsers = async () => {
          const querySnapshot = await getDocs(collection(db, "palns"));
          const usersArray = querySnapshot.docs.map(doc => ({
              id: doc.id,
              ...doc.data()
            }));
          setpalns(usersArray);
          console.log(services)

        };
        fetchUsers();

  }, [uplans]);



    /*start function to add*/
    const Addpalne= async () => {
      try {
        const docRef = await addDoc(collection(db, "palns"), {
        title:addplane.title,
        price:addplane.price,
        skils1:addplane.skils1,
        skils2:addplane.skils2,
        skils3:addplane.skils3,
        skils4:addplane.skils4,
        skils5:addplane.skils5,
        skils6:addplane.skils6
        });
        console.log("Document ID:", docRef.id);
        setuppp(docRef.id);
             
      } catch (error) {
        console.error("Error adding document:", error);
      }
    };
    /*end function to add*/
      /*delete*/
      const deleteplane = async (productid) => {
        try {
          await deleteDoc(doc(db, "palns", productid));
          console.log("User Deleted");
              setuppp(productid)
        } catch (error) {
          console.error("Delete Error:", error);
        }
      };
      /*delete*/

  /*plans*/
  /*message*/
  useEffect(() => {
    const fetchUsers = async () => {
        const querySnapshot = await getDocs(collection(db, "message"));
        const usersArray = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }));
       setgetmessage(usersArray)
       

      };
      fetchUsers();

}, [hdelete]);

      /*delete*/
      const deletemessage = async (productid) => {
        try {
          await deleteDoc(doc(db, "message", productid));
          console.log("User Deleted");
              hsetha(productid)
        } catch (error) {
          console.error("Delete Error:", error);
        }
      };
      /*delete*/
  /*message*/

  return (
    <div className='Dashboard'>
      <div style={{height:"100px"}}></div>
<Container>
<div className='dash-serivces'>
<h1>Services part</h1>
<div className='box-add'>
<Form>
      <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
        <Form.Label>title</Form.Label>
        <Form.Control type="title" value={adsev.title} onChange={(e)=>setadsev({...adsev,title:e.target.value}) } />
      </Form.Group>
      <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
        <Form.Label>Content</Form.Label>
        <Form.Control as="textarea" rows={3} value={adsev.text} onChange={(e)=>{
            const words = e.target.value.trim().split(/\s+/);
            if (words.length <= 50) { // التحقق من الحد الأقصى
                setadsev({...adsev,text:e.target.value})} 
                else{
                    setmssg("content")
                }
              }
           
            }     onPaste={(e) => {
                e.preventDefault(); // منع اللصق الافتراضي
                const pastedText = e.clipboardData.getData("text"); // جلب النص الملصوق
                const words = pastedText.trim().split(/\s+/);
          
                if (words.length <= 50) {
                  setadsev({ ...adsev, text: pastedText });
                  setmssg("");
                } else {
                  setmssg("Content should not exceed 25 words.");
                }
              }}/>
      </Form.Group>
      <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
        <Form.Label>image</Form.Label>
        <Form.Control type="title" value={adsev.img} onChange={(e)=>setadsev({...adsev,img:e.target.value}) }  placeholder='Image link and only one link'/>
      </Form.Group>
    </Form>
    <Button variant="primary"  onClick={()=>adsev.title!==""&&adsev.text!==""&&adsev.img!=="" ? addproduct() :setmssg("can not empety")}>Add</Button>
    <h2 style={{color:"red", padding:"0 40px"}}>{messg}</h2>
</div>
<div className='slider-box'>
          <div className='slider-container'>
            <Slider ref={sliderRef} {...settings}>
              {services.map(item => (
                <div key={item.id} className='slide'>
                  <div className='card-ser'>
                    <img src={item.img} alt={item.img} />
                    <h3>{item.title}</h3>
                    <p>
                    {item.text}
                    </p>
                    <Button variant="danger" onClick={()=>deleteproduct(item.id)}>delete</Button>
              </div>
                </div>
              ))}
            </Slider>
          </div>
          <div className='next-button-container'>
            <button className='next-button' onClick={nextSlide}>
            <i class='fa-solid fa-arrow-right'></i>
            </button>

          </div>
        </div>
      </div>

      <div className='dash-plans'>
       <h3>Plans and prices</h3>
       <Form>
      <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
        <Form.Label>title</Form.Label>
        <Form.Control type="text" value={addplane.title} onChange={(e)=>setaddplane({...addplane,title:e.target.value})} />
      </Form.Group>

      <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
        <Form.Label>price/month</Form.Label>
        <Form.Control type="number"value={addplane.price} onChange={(e)=>setaddplane({...addplane,price:e.target.value})} />
      </Form.Group>

      <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
        <Form.Label>li 1</Form.Label>
        <Form.Control type="text" value={addplane.skils1} onChange={(e)=>setaddplane({...addplane,skils1:e.target.value})}  />
      </Form.Group>
      <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
        <Form.Label>li 2</Form.Label>
        <Form.Control type="text"  value={addplane.skils2} onChange={(e)=>setaddplane({...addplane,skils2:e.target.value})} />
      </Form.Group>
      <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
        <Form.Label>li 3</Form.Label>
        <Form.Control type="text" value={addplane.skils3} onChange={(e)=>setaddplane({...addplane,skils3:e.target.value})} />
      </Form.Group>
      <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
        <Form.Label>li 4</Form.Label>
        <Form.Control type="text" value={addplane.skils4} onChange={(e)=>setaddplane({...addplane,skils4:e.target.value})} />
      </Form.Group>
      <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
        <Form.Label>li 5</Form.Label>
        <Form.Control type="text" value={addplane.skils5} onChange={(e)=>setaddplane({...addplane,skils5:e.target.value})} />
      </Form.Group>
      <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
        <Form.Label>li 6</Form.Label>
        <Form.Control type="text" value={addplane.skils6} onChange={(e)=>setaddplane({...addplane,skils6:e.target.value})}  />
      </Form.Group>

   
    
    </Form>
    <Button variant="primary"  onClick={()=>addplane.title!==""&&addplane.price!==""&&addplane.skils1!=="" &&addplane.skils2!==""&&addplane.skils3!==""&&addplane.skils4!==""&&addplane.skils5!==""&&addplane.skils6!=="" ? Addpalne() :null}>add</Button>

  


    <div className='slider-box'>
          <div className='slider-container'>
            <Slider ref={sliderRef2} {...settings}>
              {plans.map(item => (
                <div key={item.id} className='slide'>
               
        <div className='card-plans'>
            <div className='title'><h3>{item.title}</h3></div>
            <div className='card-p-in'>${item.price}/monthly</div>
            <ul>
                <li>{item.skils1}</li>
                <li>{item.skils2}</li>
                <li>{item.skils3}</li>
                <li>{item.skils4}</li>
                <li>{item.skils5}</li>
                <li>{item.skils6}</li>
            </ul>
            <Button variant="danger" onClick={()=>deleteplane(item.id)}>delete</Button>
        </div>
                </div>
              ))}
            </Slider>
          </div>
          <div className='next-button-container'>
            <button className='next-button' onClick={nextSlide2}>
            <i class='fa-solid fa-arrow-right'></i>
            </button>
          </div>
        </div>

        <div className='slider-box'>
          <div style={{textAlign:"center", color:"balck",fontSize:"35px"}}>Messages section</div>
          <div className='slider-container'>
            <Slider ref={sliderRef3} {...settings}>
              {getmessage.map(item => (
           <Card style={{ width: '18rem' }} key={item.id}>
           <Card.Body>
             <Card.Title>{item.name}</Card.Title>
             <Card.Subtitle className="mb-2 text-muted">{item.email}</Card.Subtitle>
             <Card.Text>
               {item.message}
             </Card.Text>
             <Card.Link href={`https://mail.google.com/mail/?view=cm&fs=1&to=${item.email}`} target="_blank">Reply</Card.Link>
             <Button variant="danger" onClick={()=>deletemessage(item.id)}style={{float:"right"}}>Delete</Button>
           </Card.Body>
         </Card>
              ))}
            </Slider>
          </div>
          <div className='next-button-container'>
            <button className='next-button' onClick={nextSlide3}>
            <i class='fa-solid fa-arrow-right'></i>
            </button>
          </div>
        </div>



      </div>
</Container>
    </div>
  );
}



